import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CandidateLocationComponent extends Vue {

    @Prop({default: undefined}) public district!: string | undefined;
    @Prop({default: undefined}) public city!: string | undefined;
    @Prop({default: undefined}) public profession!: string | undefined;
    @Prop({default: undefined}) public sector!: string | undefined;

    public get show(): boolean {

        return !(!this.location && !this.profession && !this.sector);
    }

    public get location(): string | undefined {

        if (this.district && this.city) {

            return `${this.district}, ${this.city}`;

        } else {

            if (this.district) {

                return this.district;
            }

            if (this.city) {

                return this.city;
            }
        }

        return undefined;
    }
}
